import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconMessage from "@arco-design/web-react/icon/react-icon/IconMessage";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import request from '@/utils/request';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
export default function RegisterForm() {
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [agreementVisible, setAgreementVisible] = useState(false);
  const [identifierValid, setIdentifierValid] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const history = useHistory();
  const t = useLocale(locale);
  function afterRegisterSuccess() {
    // 跳转登录页
    window.location.href = '/login';
  }
  function register(params) {
    setErrorMessage('');
    setLoading(true);
    request.post('/v1/user/register', params).then(res => {
      const {
        code,
        message
      } = res.data;
      if (code === 200) {
        afterRegisterSuccess();
      } else {
        setErrorMessage(message || t['register.form.register.errMsg']);
      }
    }).finally(() => {
      setLoading(false);
    });
  }
  function onSubmitClick() {
    formRef.current.validate().then(() => {
      setAgreementVisible(true);
    }).catch(() => {
      // ignore validation error
    });
  }
  function onAgreementOk() {
    setAgreementVisible(false);
    formRef.current.validate().then(values => {
      register(values);
    }).catch(() => {
      // ignore validation error
    });
  }
  function onGetVerifyCodeClick() {
    formRef.current.validate(['identifier']).then(values => {
      setLoading(true);
      values.type = 'register';
      request.post('/v1/user/verify_code', values).then(res => {
        const {
          code,
          message
        } = res.data;
        if (code === 200) {
          setCountdown(60);
        } else {
          setErrorMessage(message || t['register.form.getVerifyCode.errMsg']);
        }
      }).finally(() => {
        setLoading(false);
      });
    });
  }
  function onValuesChange(changedValues, allValues) {
    if (changedValues.identifier !== undefined) {
      formRef.current.validate(['identifier']).then(() => {
        setIdentifierValid(true);
      }).catch(() => {
        setIdentifierValid(false);
      });
    }
  }
  React.useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-title']
  }, t['register.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-sub-title']
  }, t['register.form.subtitle']), /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement(_Form, {
    className: styles['register-form'],
    layout: "vertical",
    ref: formRef,
    onValuesChange: onValuesChange
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "identifier",
    rules: [{
      required: true,
      message: t['register.form.identifier.errMsg']
    }, {
      validator: (value, cb) => {
        if (!value) return cb();
        if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value) && !/^1[3456789]\d{9}$/.test(value)) return cb(t['register.form.identifier.errMsg']);
        return cb();
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    allowClear: true,
    prefix: /*#__PURE__*/React.createElement(_IconUser, null),
    placeholder: t['register.form.identifier.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['register-form-verify-actions']
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "verify_code",
    rules: [{
      required: true,
      message: t['register.form.verifyCode.errMsg']
    }, {
      validator: (value, cb) => {
        if (!value) return cb();
        if (!/^\d{6}$/.test(value)) return cb(t['register.form.verifyCode.errMsg']);
        return cb();
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    allowClear: true,
    prefix: /*#__PURE__*/React.createElement(_IconMessage, null),
    placeholder: t['register.form.verifyCode.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Button, {
    disabled: !identifierValid || countdown > 0,
    type: "primary",
    onClick: onGetVerifyCodeClick,
    loading: loading,
    style: {
      marginLeft: 20
    }
  }, countdown > 0 ? `${countdown}s` : t['register.form.getVerifyCode'])), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    rules: [{
      required: true,
      message: t['register.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['register.form.password.placeholder'],
    onPressEnter: onSubmitClick,
    onBlur: () => formRef.current.setFieldValue('confirm_password', '')
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "confirm_password",
    rules: [{
      required: true,
      message: t['register.form.password.errMsg']
    }, {
      validator: (value, cb) => {
        const password = formRef.current.getFieldValue('password');
        if (!password || !value) return cb();
        if (value !== password) return cb(t['register.form.confirmPassword.errMsg']);
        return cb();
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['register.form.confirmPassword.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['register.form.register']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    className: styles['register-form-login-btn'],
    onClick: () => history.push('/login')
  }, t['register.form.login']))), /*#__PURE__*/React.createElement(_Modal, {
    title: t['register.form.agreement.title'],
    visible: agreementVisible,
    onCancel: () => setAgreementVisible(false),
    onOk: onAgreementOk,
    okText: t['register.form.agreement.okText'],
    cancelText: t['register.form.agreement.cancelText']
  }, /*#__PURE__*/React.createElement("p", null, t['register.form.agreement.confirm'], /*#__PURE__*/React.createElement("a", {
    href: "https://www.zhizaoband.com/home/privacy_file.html",
    target: "_blank",
    rel: "noreferrer"
  }, "\u300A\u667A\u9020\u5E2E\u9690\u79C1\u653F\u7B56\u300B"), t['register.form.agreement.and'], /*#__PURE__*/React.createElement("a", {
    href: "https://www.zhizaoband.com/home/service_protocol.html",
    target: "_blank",
    rel: "noreferrer"
  }, "\u300A\u667A\u9020\u5E2E\u670D\u52A1\u534F\u8BAE\u300B"))), /*#__PURE__*/React.createElement("div", {
    className: styles['agreement-tip']
  }, t['register.form.agreement.tip'], /*#__PURE__*/React.createElement("a", {
    href: "https://www.zhizaoband.com/home/privacy_file.html",
    target: "_blank",
    rel: "noreferrer"
  }, "\u300A\u667A\u9020\u5E2E\u9690\u79C1\u653F\u7B56\u300B"), /*#__PURE__*/React.createElement("a", {
    href: "https://www.zhizaoband.com/home/service_protocol.html",
    target: "_blank",
    rel: "noreferrer"
  }, "\u300A\u667A\u9020\u5E2E\u670D\u52A1\u534F\u8BAE\u300B")));
}